import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { Badge, Button, Row, Col, Typography } from "antd";
import { FlagOutlined } from "@ant-design/icons";
// import { switchQuestion } from "../../../actions/traineeAction";
import { switchQuestion } from "../../../reducers/trainee";
import "./portal.css";

const { Text } = Typography;

const Operations = () => {
  const trainee = useSelector((state) => state.trainee);
  const dispatch = useDispatch();

  const handleSwitch = (index) => {
    dispatch(switchQuestion(index));
  };

  return (
    <div
      className="question-list-wrapper"
      // style={{
      //   height:"100%",
      //   overflowY:"auto"
      // }}
    >
      <div className="question-list-inner-new">
        <Row>
          <Row style={{display:'flex',gap:10,}}>
            <Col>
              <Text className="qDf">Question No</Text>
            </Col>
            <Col>
              <Text className="qDf">Status</Text>
            </Col>
          </Row>
          {trainee.answers.map((d, i) => (
            <Row
              key={i}
              style={{ borderBottom: "1px solid #B4B4B4",width:"100%", margin:0 }  }
              align="middle"
            >
              <Col span={12} style={{ padding: "10px" }}>
                <Mark
                  no={i}
                  mark={d.isMarked}
                  ans={d.isAnswered}
                  activeIndex={trainee.activeQuestionIndex}
                  onSwitch={() => handleSwitch(i)}
                />
              </Col>
              <Col span={12} style={{ padding: "10px" }}>
                <Text className="qDf_inner">
                  {d.isAnswered ? "Completed" : "Incomplete"}
                </Text>
              </Col>
            </Row>
          ))}
        </Row>
      </div>
    </div>
  );
};

export const Mark = ({ mark, ans, no, activeIndex, onSwitch }) => {
  const isActive = activeIndex === no;
  const label = no + 1;

  if (mark) {
    const badgeContent = <FlagOutlined style={{ color: "#f5222d" }} />;
    const background = ans ? "#465D72" : "#999999";

    return (
      <Badge className="qb" count={badgeContent}>
        <Button
          onClick={onSwitch}
          style={{ background, color: "#fff" }}
        >
          {label}
        </Button>
      </Badge>
    );
  }

  return (
    <Text
      onClick={onSwitch}
      className="qDf_inner"
      style={{ fontWeight: isActive ? 900 : "normal", cursor: "pointer" }}
    >
      {label}
    </Text>
  );
};

export default Operations;
